import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ProductService } from 'src/app/services/product.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { ModalController } from '@ionic/angular';
import { VerificationModalComponent } from 'src/app/shared/verification-modal/verification-modal.component';
import { SubjectService } from 'src/app/services/subject.service';
import { CartService } from 'src/app/services/cart.service';

@Component({
  selector: 'app-alternative-contact-number',
  templateUrl: './alternative-contact-number.component.html',
  styleUrls: ['./alternative-contact-number.component.scss']
})
export class AlternativeContactNumberComponent implements OnInit {
  AlternateForm: any;
  mobileNumberPattern: RegExp = /^(413|414|050|054|055|056|052|058|04|06|02|09)\d{7}$|^784[0-9]{4}[0-9]{7}[0-9]{1}$/;
  @Output() formSubmit: EventEmitter<any> = new EventEmitter();
  mobileErrorMSG: any;
  otpIcon: string = undefined;
  verifiedAlternativeNumber: string = '';
  showOTPError = true;
  otpVerified: boolean = false;
  maskedAccountNo:any;
  token:any;
  isArabic: boolean;
  consentDone = false;
  @Input() optional: boolean = false;

  showConsentPopup: boolean = true;
  cart: any;
  mobileAndDeviceSku:boolean = false;
  showAlternateContact:boolean = false;
  showConsentTooltip:boolean = false;
  constructor(private FB: FormBuilder,private PS: ProductService, private translate: TranslateService,
    private UTS: UtilitiesService,private modalController: ModalController,private SS: SubjectService, private CRTS: CartService) {
    this.AlternateForm = this.FB.group({
      alternativeMobileNumber: [
        '',
        [
          Validators.pattern(this.mobileNumberPattern),
          Validators.minLength(9),
        ],
      ],
      alternativeNumberConsent: [false],
      enableAlternateContact: [false]
    });
  }

  ngOnInit(): void {
    const locale = this.UTS.getLocaleLanguage().toLocaleLowerCase();
    if (locale == 'ar') {
      this.isArabic = true;
    } else {
      this.isArabic = false;
    }
    this.getCart();
  }
  get errorControl() {
    return this.AlternateForm.controls;
  }
  onMobileKeyPress(element: HTMLElement) {
    this.mobileErrorMSG = undefined;
    this.otpIcon = undefined;
    let numVal = this.getControlerValue('alternativeMobileNumber');
    if (numVal.length < 10) { return }
    if (this.AlternateForm.controls['alternativeMobileNumber'].Invalid) { this.otpIcon = "error"; return; }
    else if (numVal == this.verifiedAlternativeNumber) { this.otpIcon = "verified"; return; }
    else {
      this.validateAlternativeAccount(numVal);
    }
  }
  getControlerValue(key: string) {
    return this.AlternateForm.controls[key].value
   }
 
   validateAlternativeAccount(alternativeMobileNumber: any) {
    this.otpIcon="spinner";
    this.PS.validateAlternateContact(alternativeMobileNumber).subscribe(
      (resp) => {
        if(resp.ERROR_CODE && resp.ERROR_CODE == 'VALIDATE_ALTERNATE_CONTAT.SAME_AS_PRIMARYACCOUNT') {
          this.translate.get('ALTERNATIVE_PRIMARY_ERROR').subscribe((message) => {
            this.showOTPError = true;
            this.mobileErrorMSG = message;
          });
          return;
        }

        if (resp.success == true) {
          if (resp.otpRequired == true) {
            this.otpIcon = "verify";
            this.otpVerified = false;
            return;
          }
          this.otpIcon = "verified";
          this.otpVerified = true;
        }
        
      },
      (e) => {
        // this.UTS.error(e.error.message);
        this.otpIcon="error";
        this.mobileErrorMSG = e.error.message;
      }
    );
  }
  getOtp() {
    this.otpIcon="spinner";
    let alternativeMobileNumber = this.AlternateForm.controls['alternativeMobileNumber'].value
    this.PS.generateOTP(alternativeMobileNumber).subscribe(
      (resp) => {
        this.otpIcon= undefined;
        this.maskedAccountNo = resp.maskedAccountNo;
        this.token = resp?.token;
       let data = {
        token: this.token,
        maskedAccountNo: this.maskedAccountNo,
        mobileNumber: alternativeMobileNumber,
        viewOtpScreen: true,
        checkoutFlow: true
       }
        // }
       this.openVerificationModal(data);
      },
      (e) => {
        // this.UTS.error(e.error.message);
        this.otpIcon="error";
        this.mobileErrorMSG = e.error.message;
      }
    );
    // this.PS.accountNoIndividualLoginEligibility(alternativeMobileNumber).subscribe(
    //   (data: any) => {
    //     if (data.eligible == "true") {
    //       //this.GAS.eligibilityCheck('Continue', this.mobileNumber, this.data.productType, this.data.displayName, '');
    //       this.PS.generateOTP(alternativeMobileNumber).subscribe(
    //         (resp) => {
    //           this.otpIcon= undefined;
    //           this.maskedAccountNo = resp.maskedAccountNo;
    //           this.token = resp?.token;
    //          let data = {
    //           token: this.token,
    //           maskedAccountNo: this.maskedAccountNo,
    //           mobileNumber: alternativeMobileNumber,
    //           viewOtpScreen: true,
    //           checkoutFlow: true
    //          }
    //           // }
    //          this.openVerificationModal(data);
    //         },
    //         (e) => {
    //           // this.UTS.error(e.error.message);
    //           this.otpIcon="error";
    //           this.mobileErrorMSG = e.error.message;
    //         }
    //       );
    //     } else {
    //       this.otpIcon="error";
    //       let errorTitle = 'Invalid number';
    //       let errorMessage =
    //         'Sorry, this number isn’t registered with Etisalat. Please try again with another number.';
    //       if (this.isArabic) {
    //         errorTitle = 'الرقم غير صحيح';
    //         errorMessage =
    //           'عذرًا، هذا الرقم غير مُسجل لدى اتصالات. يرجى إعادة المحاولة باستخدام رقم آخر';
    //       }
    //       this.mobileErrorMSG = `${errorTitle}: ${errorMessage}`;
    //      // this.GAS.eligibilityCheck('Continue', this.mobileNumber, this.data.productType, this.data.displayName, 'error - Not eligible');

    //     }
    //   },
    //   (e: any) => {
    //     this.otpIcon="error";
    //     this.mobileErrorMSG = this.isArabic ? 'هذا الرقم ليس مسجّلاً لدى اتصالات' : e?.error?.errorDescription;
    //  //   this.GAS.eligibilityCheck('Continue', this.mobileNumber, 'error - Not eligible', this.data.productType, this.data.displayName);

    //   }
    // );
  }

  async openVerificationModal(data) {   
    const modal = await this.modalController.create({
      component: VerificationModalComponent,
      cssClass: 'verification-modal modal-fullscreen',
      componentProps: { data: data },
    });
    modal.onDidDismiss().then((x: any) => {
      if(x && x.data && x.data.verified){
        this.otpVerified = x.data.verified;
        if(this.otpVerified) { 
        this.otpIcon="verified"; 
        this.verifiedAlternativeNumber = this.getControlerValue("alternativeMobileNumber");
        this.formSubmit.emit(this.AlternateForm);
        this.SS.refreshAlternativeContactInfo.next(true);
        if(this.getControlerValue("alternativeNumberConsent") != true) {
          this.consentDone =  false;
        }
       
      }
      console.log(" I am called "+ this.otpVerified)
      }
    })
  
    return await modal.present();
  }
  onChangeConsent(e) { // here e is a native event
    this.showConsentPopup = !this.showConsentPopup
    this.formSubmit.emit(this.AlternateForm);
  }  
  isMobileAndDeviceSku() {
    if (this.cart && this.cart?.items && this.cart?.items?.length > 0) {
      this.cart?.items?.forEach(element => {
        if ((element && element?.commerceItemType && element?.commerceItemType == 'mobileDevicesSku') || (element && element?.commerceItemType && element?.commerceItemType == 'mobilePlanSku')) {
          this.mobileAndDeviceSku = true;
        }
      });
    }
  }
  getCart() {
    this.CRTS.getShoppingCart().subscribe(
      (r: any) => {
        if (r && r.items) {
          this.cart = r;
          this.isMobileAndDeviceSku();
        }
      },
      (e) => {
        if (e && e.error) {
          this.UTS.error(e.error.message);
        }
      }
    );
  }
  onChangeAlternateContact(e) { // here e is a native event
    this.showAlternateContact = !this.showAlternateContact;
  }
  onChangeTooltip(e) { // here e is a native event
    this.showConsentTooltip = !this.showConsentTooltip;
    this.formSubmit.emit(this.AlternateForm);
  }
}
